var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-col',{staticClass:"w-full pb-4"},[_c('monthly-chart-card',{attrs:{"title":_vm.graph1.title,"year":_vm.graph1.year,"data1":_vm.graph1.data1,"data2":_vm.graph1.data2},on:{"change":_vm.yearChangeForGraph1}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }